import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicosPage = lazy(() => import('../pages/servicos/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const SimuladorPage = lazy(() => import('../pages/simulador/page'));
const VendasPage = lazy(() => import('../pages/vendas/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/servicos',
    element: <ServicosPage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/simulador',
    element: <SimuladorPage />,
  },
  {
    path: '/vendas',
    element: <VendasPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;